import "./RegisterLoader.css";

export default function RegisterLoader() {
  return (
    <div className="register-loader-overlay" role="status" aria-live="polite" aria-label="Cadastrando usuario">
      <div>
        <div className="register-loader">
          <span>
            <span />
            <span />
            <span />
            <span />
          </span>
          <div className="register-loader-base">
            <span />
            <div className="register-loader-face" />
          </div>
        </div>
        <div className="register-loader-longfazers">
          <span />
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
}
